import {texture} from "p3";
import definitions from "../../../definitions";
import Item from "./Item";

export default class ItemCleaningCloth extends Item {
    constructor() {
        super(definitions.ITEM_ID.CLEANING_CLOTH, texture("prop_cleaning_cloth_00"));
    }

    init() {
        super.init();

        this.addShadow(definitions.SHADOW_SIZE.SMALL, 1, new PIXI.Point(0, -8));
    }
}